import { render, staticRenderFns } from "./ChoiceLayout.vue?vue&type=template&id=e0364da6&scoped=true&"
import script from "./ChoiceLayout.vue?vue&type=script&lang=js&"
export * from "./ChoiceLayout.vue?vue&type=script&lang=js&"
import style0 from "./choice-layout.scss?vue&type=style&index=0&id=e0364da6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0364da6",
  null
  
)

export default component.exports